let API_HOST = process.env.REACT_APP_API_URL;

/* .............Common API ..............*/
export const APP_ENDPOINT_FETCH_GROUPLIST = API_HOST + '/user/getmygroups';
export const APP_ENDPOINT_FETCH_VEHICLELIST = API_HOST + '/vehicle/getuservehicles';
/* .............Common API ..............*/

/* .............EVDashbaord ..............*/
export const EV_ENDPOINT_FETCH_CHARGET_TRACKER_DASHBOARD = API_HOST + '/ev/dashboard';
export const EV_ENDPOINT_FETCH_TRIP_REPORT = API_HOST + '/reports/ev/getevtripreport/v3';
export const EV_ENDPOINT_FETCH_TRIP_INSIGHT = API_HOST + '/ev/utilizationinsights';

export const EV_ENDPOINT_FETCH_TRIP_INSIGHT_GRAPH_SUMMARY =
	API_HOST + '/ev/utilizationinsights/graph';

export const EV_ENDPOINT_FETCH_TRIP_INSIGHT_GRAPH_SUMMARY2 =
	API_HOST + '/ev/utilizationinsights/graph2';
export const GET_VEHICLE_BY_GROUP = API_HOST + '/vehicle/getevgroupvehicles';

/* .............EVDashbaord ..............*/
